import { addMonths, eachDayOfInterval, endOfMonth, endOfWeek, format, isSameMonth, isToday, startOfMonth, startOfWeek } from "date-fns";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const MonthCalendar = ({ month, setMonth, concerts, booked, onPick }) => {
  const days = eachDayOfInterval({ start: startOfWeek(startOfMonth(month)), end: endOfWeek(endOfMonth(month)) });
  const byDate = (list) => list.reduce((m, x) => ({ ...m, [x.date]: [...(m[x.date] || []), x] }), {});
  const shows = byDate(concerts);
  const books = byDate(booked);

  return (
    <div className="card-surface rounded-2xl p-4 sm:p-6" data-testid="concert-calendar">
      <div className="flex items-center justify-between mb-6">
        <h2 data-testid="calendar-month-label" className="font-cond uppercase font-bold tracking-wider text-3xl">{format(month, "MMMM yyyy")}</h2>
        <div className="flex gap-2">
          <button data-testid="calendar-prev-button" onClick={() => setMonth(addMonths(month, -1))} className="btn-line rounded-full w-10 h-10 flex items-center justify-center" aria-label="Previous month"><ChevronLeft className="w-4 h-4" /></button>
          <button data-testid="calendar-next-button" onClick={() => setMonth(addMonths(month, 1))} className="btn-line rounded-full w-10 h-10 flex items-center justify-center" aria-label="Next month"><ChevronRight className="w-4 h-4" /></button>
        </div>
      </div>
      <div className="grid grid-cols-7 gap-1 sm:gap-2 text-center font-cond uppercase tracking-widest text-xs text-slate-500 mb-2">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => <div key={d}>{d}</div>)}
      </div>
      <div className="grid grid-cols-7 gap-1 sm:gap-2">
        {days.map((day) => {
          const key = format(day, "yyyy-MM-dd");
          const dayShows = shows[key] || [];
          const dayBooks = books[key] || [];
          return (
            <div key={key} data-testid={`calendar-day-${key}`}
              className={`min-h-[72px] sm:min-h-[104px] rounded-lg border p-1.5 sm:p-2 text-left ${isSameMonth(day, month) ? "border-[#222634] bg-[#0d0f14]" : "border-transparent opacity-30"} ${dayShows.length ? "!border-[#00d436]/50" : ""}`}>
              <div className={`font-mono-ui text-xs ${isToday(day) ? "text-lime font-bold" : "text-slate-400"}`}>{format(day, "d")}</div>
              <div className="mt-1 space-y-1">
                {dayShows.map((c) => (
                  <button key={c.id} onClick={() => onPick(c)} data-testid={`calendar-concert-${c.id}`}
                    className="w-full text-left rounded bg-lime text-black px-1.5 py-1 text-[10px] sm:text-[11px] font-bold leading-tight hover:brightness-110 transition-[filter] truncate">
                    <span className="hidden sm:inline">{c.city.split(",")[0]} · </span>Tickets
                  </button>
                ))}
                {dayBooks.map((b) => (
                  <div key={b.id} data-testid={`calendar-booked-${b.id}`}
                    className="rounded bg-[#a855f7]/20 border border-[#a855f7]/50 text-[#d8b4fe] px-1.5 py-1 text-[10px] sm:text-[11px] font-bold leading-tight truncate">
                    Booked<span className="hidden sm:inline"> · {b.city.split(",")[0]}</span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
      <div className="flex gap-6 mt-5 text-xs text-slate-400">
        <span className="flex items-center gap-2"><span className="w-3 h-3 rounded-sm bg-lime" /> Show with tickets</span>
        <span className="flex items-center gap-2"><span className="w-3 h-3 rounded-sm bg-[#a855f7]/60" /> Booked private event</span>
      </div>
    </div>
  );
};
